import React from "react";
import { useInStockProductPageContext } from "web/react/pages/product/in-stock/in-stock-product-page/in-stock-product-page.context";
import { PDPSuggestedProducts } from "web/react/pages/product/in-stock/pdp-suggested-products";
import { InStockAffiliateProductLayoutSerializer } from "web/types/serializers";

export function SuggestedProduct({
    productLayout,
}: {
    productLayout: InStockAffiliateProductLayoutSerializer;
}): JSX.Element | null {
    const { designer } = useInStockProductPageContext();
    const {
        related_products: relatedProducts,
        curated_ads: curatedAds,
        brand_ad: brandAd,
        adsense_for_shopping: adsenseForShopping,
        product_breadcrumbs: productBreadcrumbs,
        related_designers_category_rail: relatedDesignersCategoryRail,
        recently_viewed_products: recentlyViewedProducts,
        related_search_rail: relatedSearchRail,
        is_authenticated: isAuthenticated,
        is_following: isFollowing,
        features,
    } = productLayout;

    return (
        <PDPSuggestedProducts
            relatedProducts={relatedProducts}
            curatedAds={curatedAds}
            brandAd={brandAd}
            adsenseForShopping={adsenseForShopping}
            productBreadcrumbs={productBreadcrumbs}
            relatedDesignersCategoryRail={relatedDesignersCategoryRail}
            recentlyViewedProducts={recentlyViewedProducts}
            relatedSearchRail={relatedSearchRail}
            isAuthenticated={isAuthenticated}
            isFollowing={isFollowing}
            designer={designer}
            features={features}
        />
    );
}
